var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('editor-content',{staticClass:"tiptap-reply",attrs:{"editor":_vm.editor},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.handleEnter.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }